import { createKeys, featureKeys } from "Utilities/ReactQuery/fnKeys";

const HOUSEHOLDS_KEY = "households";
const FILTERS_KEY = "filters";
const METADATA_KEY = "metadata";

const houseHoldDatabaseKeys = createKeys(
  featureKeys.HOUSEHOLD_DATABASE_FEATURE_KEY,
  {
    households: ({ filter } = {}) => [HOUSEHOLDS_KEY, { filter }],
    filters: () => [FILTERS_KEY],
    metadata: () => [METADATA_KEY],
  }
);

export default houseHoldDatabaseKeys;
